/**
 * Deprecated - This file will be removed in the future. Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 **/
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { UpgradeEditionButtonProps } from '../src/Upgrade/UpgradeEditionButton.tsx';

export const UpgradeEditionButton: LoadableType<UpgradeEditionButtonProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UpgradeEditionButton" */ '../src/Upgrade/UpgradeEditionButton.tsx'
			)
		).UpgradeEditionButton,
});
